var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipFish({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.89 11.23C15.67 11.23 15.51 11.41 15.51 11.61V11.69C15.51 11.91 15.68 12.04 15.89 12.04C16.1 12.04 16.27 11.83 16.27 11.62C16.27 11.41 16.1 11.24 15.89 11.24V11.23Z",
    fill: "#00AEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM8.85 7.17C10.43 6.71 12.08 7.21 13.21 8.46C12 8.41 10.81 8.63 9.69 9.11C9.34 8.46 8.92 7.86 8.43 7.32C8.57 7.27 8.71 7.22 8.85 7.17ZM11.18 16.83C10.81 16.94 10.43 17 10.06 17C10.2 16.68 10.31 16.34 10.41 15.99C11 16.18 11.61 16.31 12.23 16.36C11.9 16.56 11.54 16.72 11.18 16.83ZM18.86 12.47C18.46 13.06 17.97 13.58 17.41 14.03C14.62 16.27 10.54 16.12 7.94 13.68L7.52 13.29L7.31 13.82C6.95 14.75 6.08 15.35 5.1 15.38C5.15 14.4 5.59 13.47 6.33 12.82L6.68 12.51L6.31 12.23C5.59 11.68 5.15 10.84 5.1 9.94V9.54C6.02 9.68 6.82 10.28 7.22 11.14L7.45 11.63L7.83 11.25C8.19 10.9 8.6 10.59 9.02 10.32C12.34 8.26 16.7 9.2 18.86 12.43L18.83 12.48L18.86 12.47Z",
    fill: "#00AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipFish);
export default __webpack_public_path__ + "static/media/ic-chip-fish.2f408c379d938b8bc27f8ea27b291cf3.svg";
export { ForwardRef as ReactComponent };